<template>
  <section class="py-16" :style="componentStyle" :id="sectionId">
    <v-container>
      <v-row
        justify="center"
        :align="align"
      >
        <v-col
          cols="12"
          md="6"
          :align="alignImg"
          order="0"
          :order-sm="orderImg"
        >
          <img
            :src="imgUrl"
            alt=""
            class="img-fluid"
          >
        </v-col>
        <v-col
          cols="12"
          md="6"
          :align="alignText"
          order="1"
          :order-sm="orderText"
        >
          <h1 class="headertext">{{title}}</h1>
          <p
            class="bottomtext"
            v-html="text"
          ></p>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>
<script>
import promotionPageMixin from '../mixins/promotion-page'
export default {
   mixins: [promotionPageMixin],
  props: {
    imgUrl: {
      type: String
    },
    title: {
      type: String
    },
    text: {
      type: String
    },
    align: {
      type: String,
      default: undefined
    },
    imgPosition: {
      required: false,
      type: String,
      default: 'left'
    }
  },
  computed: {
    alignImg () {
      return this.imgPosition === 'left' ? 'left' : 'right'
    },
    orderImg () {
      return this.imgPosition === 'left' ? 0 : 1
    },
    alignText () {
      return this.imgPosition === 'left' ? 'right' : 'left'
    },
    orderText () {
      return this.imgPosition === 'left' ? 1 : 0
    }
  }
}
</script>
<style scoped>
h1 {
  font-family: "Niveau Grotesk";
  font-size: 42px;
}

.headertext {
  display: block;
  text-align: left;
  width: 450px;
}

.bottomtext {
  display: block;
  text-align: left;
  font-family: "Niveau Grotesk";
  padding-top: 39px;
  font-size: 20px;
  width: 450px;
}

@media only screen and (max-width: 600px) {
  img {
    width: 100%;
  }

  .headertext {
    text-align: center;
    width: 100%;
  }

  .bottomtext {
    text-align: center;
    width: 100%;
    padding: 10px;
    margin: auto;
  }

  .bottomtext:last-child {
    margin-bottom: 20px;
  }
}
</style>
